import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import $ from 'jquery';

Rails.start();
Turbolinks.start();
global.Turbolinks = Turbolinks;
global.$ = $;
global.jQuery = $;

document.addEventListener('click', function (event) {
  var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
  if (!link) {
    return;
  }

  var href = link.getAttribute('href') || '';
  if (href.charAt(0) === '#' || link.target === '_blank' || link.hasAttribute('download')) {
    return;
  }

  var url;
  try {
    url = new URL(href, window.location.href);
  } catch (error) {
    return;
  }

  if (url.origin !== window.location.origin) {
    return;
  }

  window.__kairosPreserveScrollForNextVisit = link.dataset.scrollTop === 'false' || Boolean(url.hash);
  window.setTimeout(function () {
    window.__kairosPreserveScrollForNextVisit = false;
  }, 0);
}, true);

document.addEventListener('turbolinks:before-visit', function (event) {
  var url;
  try {
    url = new URL(event.data.url, window.location.href);
  } catch (error) {
    return;
  }

  if (window.__kairosPreserveScrollForNextVisit || url.hash) {
    window.__kairosPreserveScrollForNextVisit = false;
    return;
  }

  window.__kairosScrollTopAfterVisit = true;
});

function resetKairosScrollAfterVisit() {
  if (!window.__kairosScrollTopAfterVisit) {
    return;
  }

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

document.addEventListener('turbolinks:render', resetKairosScrollAfterVisit);

document.addEventListener('turbolinks:load', function () {
  if (!window.__kairosScrollTopAfterVisit) {
    return;
  }

  resetKairosScrollAfterVisit();
  window.requestAnimationFrame(function () {
    resetKairosScrollAfterVisit();
    window.requestAnimationFrame(function () {
      resetKairosScrollAfterVisit();
      window.__kairosScrollTopAfterVisit = false;
    });
  });
});

require('./packs/custom/places');
require('./packs/custom/newsletter');
require('./packs/custom/web_vitals');
